import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccountInfoAccordion from './AccountInfoAccordion';
import AccountInfoHeader from './AccountInfoHeader';
import TopUp from '../../../../../common/topUp';
import { Modal } from '../../../../../common/modal';
import BookmakerLink from '../../../../../common/bookmakerLink';
import { getGamblingCompliance } from '../../../../../common/gamblingCompliance';
import getTopUpErrorMessage from '../../../../../common/topUp/components/topUpErrors';

class AccountInfoIntegrated extends Component {
    static defaultProps = {
        cardDetails: null,
        isCardDetailsError: false,
        topUpErrorInfo: null,
        withdrawBookmakerUrl: '',
        withdrawBookmakerName: '',
        topUpBookmakerUrl: '',
        topUpBookmakerName: '',
        topUpPhoneNumber: '',
        isExternalLogout: false,
    };
    static propTypes = {
        isTopUpIntegrated: PropTypes.bool.isRequired,
        isBalanceVisible: PropTypes.bool.isRequired,
        isTopUpModalVisible: PropTypes.bool.isRequired,
        withdrawBookmakerUrl: PropTypes.string,
        withdrawBookmakerName: PropTypes.string,
        topUpBookmakerUrl: PropTypes.string,
        topUpBookmakerName: PropTypes.string,
        topUpPhoneNumber: PropTypes.string.isRequired,
        currencySign: PropTypes.string.isRequired,
        cardDetails: PropTypes.shape({
            cardId: PropTypes.string,
            cardNumber: PropTypes.string,
        }),
        isCardDetailsError: PropTypes.bool,
        topUpErrorInfo: PropTypes.shape({
            code: PropTypes.string,
        }),
        feed: PropTypes.string.isRequired,
        theme: PropTypes.shape({
            checkboxIconType: PropTypes.string.isRequired,
        }).isRequired,
        isPhone: PropTypes.bool.isRequired,
        apiName: PropTypes.string.isRequired,
        getUserInfo: PropTypes.func.isRequired,
        toggleBalanceVisibility: PropTypes.func.isRequired,
        requestLogout: PropTypes.func.isRequired,
        hideTopUpModal: PropTypes.func.isRequired,
        topUpAccountBalance: PropTypes.func.isRequired,
        getCardDetails: PropTypes.func.isRequired,
        resetTopUpForm: PropTypes.func.isRequired,
        isExternalLogout: PropTypes.bool,
    };

    onLogoutClick = () => {
        this.props.requestLogout(
            this.props.apiName,
            this.props.feed,
            this.props.isExternalLogout,
        );
    }

    onModalClose = () => {
        this.props.hideTopUpModal();
        if (!this.props.topUpErrorInfo) {
            this.props.resetTopUpForm();
        }
    }

    toggleBalanceVisibility = () => {
        this.props.toggleBalanceVisibility(this.props.feed);
    }

    render() {
        const {
            withdrawBookmakerName,
            topUpErrorInfo,
            feed,
            theme: { checkboxIconType },
        } = this.props;

        const gamblingCompliance = getGamblingCompliance(feed);
        const topUpMessage = topUpErrorInfo
            ? getTopUpErrorMessage(topUpErrorInfo, feed)
            : 'Deposit is successful';
        return (
            <div className="bs-accountInfo">
                <AccountInfoHeader
                    isBalanceVisible={this.props.isBalanceVisible}
                    checkboxIconType={checkboxIconType}
                    onToggleBalanceVisibility={this.toggleBalanceVisibility}
                    onLogoutClick={this.onLogoutClick}
                />
                <div className="bs-accountInfo__accordions">
                    <AccountInfoAccordion title="Deposit">
                        <TopUp
                            apiName={this.props.apiName}
                            feed={feed}
                            isTopUpIntegrated={this.props.isTopUpIntegrated}
                            topUpBookmakerUrl={this.props.topUpBookmakerUrl}
                            topUpBookmakerName={this.props.topUpBookmakerName}
                            topUpPhoneNumber={this.props.topUpPhoneNumber}
                            currencySign={this.props.currencySign}
                            cardDetails={this.props.cardDetails}
                            isCardDetailsError={this.props.isCardDetailsError}
                            isPhone={this.props.isPhone}
                            getUserInfo={this.props.getUserInfo}
                            topUpAccountBalance={this.props.topUpAccountBalance}
                            getCardDetails={this.props.getCardDetails}
                        />
                        <Modal
                            visible={this.props.isTopUpModalVisible}
                            onOverlayClick={this.onModalClose}
                        >
                            <div className="bs-topUpModal">
                                <span className="bs-topUpModal__message">
                                    {topUpMessage}
                                </span>
                                <button
                                    className="bs-btn bs-btn_major bs-btn_2XL bs-topUpModal__button"
                                    onClick={this.onModalClose}
                                >
                                    <span>OK</span>
                                </button>
                            </div>
                        </Modal>
                    </AccountInfoAccordion>

                    <AccountInfoAccordion title="Withdraw">
                        <BookmakerLink
                            titleText={`To withdraw visit ${withdrawBookmakerName}`}
                            bookmakerUrl={this.props.withdrawBookmakerUrl}
                            bookmakerName={withdrawBookmakerName}
                        />
                    </AccountInfoAccordion>

                    <AccountInfoAccordion title="Terms & Conditions">
                        <div className="bs-accountInfo__tc">
                            {gamblingCompliance}
                        </div>
                    </AccountInfoAccordion>
                </div>
            </div>
        );
    }
}

export default AccountInfoIntegrated;



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/accountPage/components/accountInfo/components/AccountInfoIntegrated.jsx